module.exports = __webpack_public_path__ + "img/img-right.4fec89d.png";